var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgExclamation = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.47748 0 0 4.47748 0 10C0 15.5232 4.47748 20 10 20C15.5232 20 20 15.5238 20 10C20 4.47748 15.5231 0 10 0ZM10 18.125C5.51253 18.125 1.87503 14.4875 1.87503 10C1.87503 5.51253 5.51253 1.87503 10 1.87503C14.4875 1.87503 18.125 5.51253 18.125 10C18.125 14.4875 14.4875 18.125 10 18.125ZM10.0006 4.38561C9.2844 4.38561 8.74247 4.75938 8.74247 5.36311V10.9006C8.74247 11.505 9.28433 11.8775 10.0006 11.8775C10.6994 11.8775 11.2588 11.4894 11.2588 10.9006V5.36311C11.2587 4.77371 10.6994 4.38561 10.0006 4.38561ZM10.0006 13.125C9.31251 13.125 8.75247 13.685 8.75247 14.3737C8.75247 15.0612 9.31251 15.6212 10.0006 15.6212C10.6888 15.6212 11.2482 15.0612 11.2482 14.3737C11.2481 13.685 10.6888 13.125 10.0006 13.125Z",
    fill: "#FDBE14"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExclamation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/exclamation.6ce10727.svg";
export { ForwardRef as ReactComponent };